import { gql } from "lib/apolloClient";

export const LtiFragment = {
  ltiFragment: gql`
    fragment ltiFragment on LTILaunchObject {
      launchUrl
      launchObject
      errorFlag
      stopLinkCreation
      attachmentContextId
    }
  `,
};
